import React from "react";
import "../../assets/styles/components/alert.scss";
import {useDispatch} from "react-redux";
import {appSetToggle} from "../../store/actions/appAction";

export default function PopupFader(props) {
    const {show} = props;
    const dispatch = useDispatch();

    return show ? (
        <div
            className={"position-fixed top-0 w-100 h-100"}
            style={{zIndex: 1}}
            onClick={() => dispatch(appSetToggle(false))}
        />
    ) : null;
}
